import React from 'react';
import { Tag, Tooltip } from 'src/components/matchbox';
import useUniqueId from 'src/hooks/useUniqueId';
import { TLS_STATUS_CONFIG } from '../constants/tlsStatus';

function resolveConfig(tlsStatus, verified) {
  const statusConfig = TLS_STATUS_CONFIG[tlsStatus];

  // Always use status-based configuration for the badge
  if (statusConfig) {
    if (tlsStatus === 'unknown' && !verified) {
      return {
        ...statusConfig,
        tooltip: 'Verify the domain to enable a TLS certificate'
      };
    }
    return statusConfig;
  }

  return null;
}

export default function TlsStatusBadge({ tlsStatus, verified }) {
  const tooltipId = useUniqueId('tls-status');
  const config = resolveConfig(tlsStatus, verified);

  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <Tooltip content={config.tooltip} id={tooltipId} dark>
      <Tag color={config.color}>
        <Icon size={15} />
        <span> {config.label}</span>
      </Tag>
    </Tooltip>
  );
}
